// Onboarding is tracked by its own flag, so a project bumped to a later phase still prompts the client.
export const selectPendingOnboarding = (list: any): any[] => {
  if (!Array.isArray(list)) return [];

  return list.filter((project: any) => {
    if (!project || typeof project !== "object") return false;
    // A deleted or archived project is never pending, whatever its onboarding flag says.
    if (project.is_deleted === true || project.is_archived === true)
      return false;
    // Older API builds omit the flag; fall back so a deploy skew cannot prompt every project at once.
    if (typeof project.is_onboarded !== "boolean") {
      return (project.status || "").toLowerCase() === "onboarding";
    }
    return !project.is_onboarded;
  });
};

export const ONBOARDING_DISMISSED_KEY = "onboarding_dismissed";

/** True once the client has backed out of onboarding for this session. */
export const isOnboardingDismissed = (): boolean => {
  try {
    return sessionStorage.getItem(ONBOARDING_DISMISSED_KEY) === "1";
  } catch {
    return false;
  }
};

interface OnboardingEntryContext {
  pathname: string;
  list: any;
}

/** False when onboarding must not be entered, so callers can skip the fetch. */
export const canEnterOnboarding = (pathname: string): boolean => {
  if (pathname.includes("/auth/onboarding")) return false;
  return !isOnboardingDismissed();
};

// Every redirect into onboarding runs through here, so "Back to Projects"
// cannot be undone by a caller that forgot to check the dismissal flag.
export const onboardingProjectsToEnter = ({
  pathname,
  list,
}: OnboardingEntryContext): any[] => {
  if (!canEnterOnboarding(pathname)) return [];
  return selectPendingOnboarding(list);
};
